import page from "page";
import { map } from "./router";

import dayjs from "dayjs";
import "./ext";
import accountIndex from "./pages/account";
import login from "./pages/auth/login";
import listChatClients from "./pages/chat-clients";
import viewChatClient from "./pages/chat-clients/[id]";
import chatClientChat from "./pages/chat-clients/chat";
import createSession from "./pages/chat-clients/sessions/create";
import viewSessions from "./pages/chat-clients/sessions/index";
import collections from "./pages/collections";
import collectionDocumentsIndex from "./pages/collections/documents";
import viewCollectionDocument from "./pages/collections/documents/[id]";
import collectionNavigation from "./pages/collections/navigation";
import collectionPlayground from "./pages/collections/playground";
import dashboard from "./pages/dashboard";
import listGateways from "./pages/gateways";
import viewGateway from "./pages/gateways/[id]";
import pageIndex from "./pages/index";

var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

map('/', pageIndex);
map('/login', login);
map('/dashboard', dashboard);
map('/dashboard/collections', collections);
map('/dashboard/collections/:id', ctx => page.redirect(`/dashboard/collections/${ctx.params.id}/documents`));
map('/dashboard/collections/:id/navigation', collectionNavigation);
map('/dashboard/collections/:id/playground', collectionPlayground);
map('/dashboard/collections/:id/documents', collectionDocumentsIndex);
map('/dashboard/collections/:id/documents/:documentid', viewCollectionDocument);
map('/dashboard/ai-gateways', listGateways);
map('/dashboard/gateways/:gatewayId', viewGateway);
map('/dashboard/chat-clients', listChatClients);
map('/dashboard/chat-clients/:id', viewChatClient);
map('/dashboard/chat-clients/:id/sessions', viewSessions);
map('/dashboard/chat-clients/:id/sessions/create', createSession);
map('/dashboard/account', accountIndex);

map('/chat/:key', chatClientChat);

document.addEventListener("DOMContentLoaded", () => {
    page();
});
window.addEventListener("resize", () => {
    document.querySelectorAll("[redrawable]").forEach(e => {
        if (e.redraw) {
            e.redraw();
        }
    });
})

// hover events
let dragCounter = 0;

document.addEventListener("dragenter", ev => {
    ev.preventDefault();
    dragCounter++;
    if (dragCounter === 1) {
        document.body.classList.add("dragging");
    }
});
document.addEventListener("dragleave", ev => {
    ev.preventDefault();
    dragCounter--;
    if (dragCounter === 0) {
        document.body.classList.remove("dragging");
    }
});
document.addEventListener("dragover", ev => {
    ev.preventDefault();
});
document.addEventListener("drop", ev => {
    ev.preventDefault();
    dragCounter = 0;
    document.body.classList.remove("dragging");
    if (window._dragHandler) {
        window._dragHandler(ev);
    }
});
